import { CHAUFFER_ASSIGN, CHAUFFER_ASSIGN_SUCCESS, CHAUFFER_ASSIGN_ERROR, CHAUFFER_ASSIGN_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ChaufferAssign = (state = initialState, action) => {
  switch (action.type) {
    case CHAUFFER_ASSIGN:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CHAUFFER_ASSIGN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CHAUFFER_ASSIGN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case CHAUFFER_ASSIGN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ChaufferAssign;
